var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`base-spinner base-spinner__${_vm.variant}`})
}
var staticRenderFns = []

export { render, staticRenderFns }